import { observable, action } from "mobx";


export class AdminContentVM {
    constructor() { }

    @observable editErrorClicked: boolean = false;
    @observable originalErrorCode: string = ""

    @observable selectedSection: string = 'release-notes';
    @observable collapseNewsCard: boolean = false;
    @observable collapseButtomCard: boolean = false;

    @action.bound setSelectedSection = (value: string) => this.selectedSection = value
    @action.bound setcollapseNewsCard = (value: boolean) => this.collapseNewsCard = value
    @action.bound setcollapseButtomCard = (value: boolean) => this.collapseButtomCard = value

    
    @action.bound changeTab = (section: string) => {
        if (this.selectedSection !== section) {
            this.setSelectedSection(section);
        }
    };

    @action.bound clickedCollapseNewsCard = () => this.setcollapseNewsCard(!this.collapseNewsCard)
    @action.bound clickedCollapseButtomCard = () =>  this.setcollapseButtomCard(!this.collapseButtomCard)

}